import ValidateForm from "./form/validate";
import Variants from "./form/variants";
import Store from "../store";
import MarkFirstVariant from "./form/markFirstVariant";
import globals from "../../common/globals";

const FormPurchase = {
  attrDisplayOrder: globals.attrDisplayOrder || [1, 2, 3],
  attrMarkFirst: globals.attrMarkFirst || [true, true, true],
  lastUnitsLimit: globals.lastUnitsLimit || 3,
  useLocals: globals.useLocals || false,

  errorLog: function (functionName, variables) {
    const logVariables = variables || null;

    console.error(`${functionName} - Variáveis não definidas.`);

    if (logVariables !== null && typeof logVariables === "object") {
      for (const [key, value] of Object.entries(logVariables)) {
        console.error(`${key}: ${value}`);
      }
    }

    return;
  },

  handleFormInfos: function (form, variant) {
    if (!form || !variant) {
      FormPurchase.errorLog("handleFormInfos", { form, variant });
      return;
    }

    const skuInput = form.querySelector('[name="sku"]');
    const qtdInput = form.querySelector('[name="quantity"]');
    const errorMsgEl = form.querySelector(".msg-response .msg-error");

    // -> VALIDAR OBJ VAZIO
    if (!variant || !skuInput || !qtdInput) {
      // considerar throw de error e invalidar formulário
      console.error(
        "handleFormInfos: Sem variante disponível, ou sem input de sku, ou sem input de quantidade"
      );
      return;
    }

    skuInput.value = variant.sku;
    qtdInput.value = 1;
    qtdInput.setAttribute("data-available-quantity", variant.stock);

    if (errorMsgEl) {
      errorMsgEl.classList.remove("-visible");
      errorMsgEl.innerHTML = "";
    }

    return FormPurchase.changeSkuEvent(form, variant);
  },

  changeSkuEvent: function (form, variant) {
    if (!form || !variant) {
      FormPurchase.errorLog("changeSkuEvent", { form, variant });
      return;
    }

    const event = new CustomEvent("vnda:sku-change", {
      detail: { sku: variant.sku },
    });
    const productContainer = form.closest("[data-product-box]");
    if (productContainer) productContainer.dispatchEvent(event);

    // Chama a função para sincronizar os atributos do bloco principal e do flutuante
    if (window.floatingBuyInstance) {
      const floatingBuy = window.floatingBuyInstance;
      floatingBuy.watchAttributes(form, variant);
    }

    return form.dispatchEvent(event);
  },

  handleQuantitySelector: function (form) {
    const errorMsgEl = form.querySelector(".msg-response .msg-error");
    const buttons = form.querySelectorAll("[data-qtd-plus], [data-qtd-minus]");
    const qtdInput = form.querySelector('[name="quantity"]');

    if (!qtdInput) {
      // considerar throw de error e invalidar formulário
      console.error("Sem input de quantidade");
      return;
    }

    if (buttons.length == 0) return;

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const type = button.hasAttribute("data-qtd-plus") ? "plus" : "minus";
        const newQtd = Number(qtdInput.value) + (type == "plus" ? +1 : -1);
        const availableQtd = Number(
          qtdInput.getAttribute("data-available-quantity")
        );

        if ((!availableQtd || availableQtd == 0) && errorMsgEl) {
          errorMsgEl.innerHTML = "Produto em falta no estoque";
          errorMsgEl.classList.add("-visible");
          return;
        }

        if (newQtd > availableQtd && errorMsgEl) {
          errorMsgEl.innerHTML = "Quantidade máxima em estoque.";
          errorMsgEl.classList.add("-visible");
          return;
        }

        if (newQtd > 0) {
          qtdInput.value = newQtd;
          qtdInput.setAttribute("value", newQtd);
        }

        if (errorMsgEl) {
          errorMsgEl.classList.remove("-visible");
          errorMsgEl.innerHTML = "";
        }
      });
    });
  },

  handleDropdowns: function (form) {
    // Lida com o funcionamento de possíveis dropdowns dos atributos
    // dropdowns são feitos divs auxiliares, não com o input <select>
    const dropdowns = form.querySelectorAll(".prod-option.-dropdown");
    if (!dropdowns) return;

    // Configura abre/fecha do dropdown conforme clique nas opções
    return dropdowns.forEach((dropdown) => {
      let dropdownProcessed = dropdown.getAttribute("data-dropdown-processed");

      if (dropdownProcessed) return;

      dropdown.setAttribute("data-dropdown-processed", true);

      const dropAttrs = dropdown.querySelectorAll(
        "[data-attribute-value], [data-customization] + label"
      );
      dropdown.querySelector(".inner").classList.remove("-choosing");

      dropAttrs.forEach((attr) => {
        attr.addEventListener("click", () => {
          attr.closest(".inner").classList.toggle("-choosing");

          // Garante que os outros dropdowns fechem quando clica em um novo
          dropdowns.forEach((checkDrop) => {
            if (checkDrop === dropdown) return;
            checkDrop.querySelector(".inner").classList.remove("-choosing");
          });
        });
      });
    });
  },

  handleOptionsOrder: function (form) {
    // Altera a ordem de exibição dos atributos em tela
    // com base na ordem definida na array attrDisplayOrder
    FormPurchase.attrDisplayOrder.forEach((order, index) => {
      const thisOrderEl = form.querySelector(`[data-attribute="${order}"]`);
      if (thisOrderEl) thisOrderEl.style.order = index;
    });
  },

  handleOptionNameSelected: function (form) {
    // Exibe o valor da opção selecionada ao lado do nome do atributo
    const selectedInputs = [
      form.querySelector('[data-attribute="1"] input:checked'),
      form.querySelector('[data-attribute="2"] input:checked'),
      form.querySelector('[data-attribute="3"] input:checked'),
    ];

    selectedInputs.forEach((input, index) => {
      if (!input) return;

      const target = form.querySelector(`[data-attr-name="${index + 1}"]`);
      if (!target) return;

      const valueTrimmed = input.value.split("|")[0];
      target.innerHTML = valueTrimmed;
      target.classList.add("-visible");
    });
  },

  handleLastUnits: function (form, variant) {
    if (!variant || !form) {
      FormPurchase.errorLog("handleLastUnits", { form, variant });
      return;
    }

    const lastUnitsEl = form.querySelector(".last-units");
    if (!lastUnitsEl) return;

    const quantity = variant.stock;

    if (quantity <= FormPurchase.lastUnitsLimit) {
      if (!quantity) {
        lastUnitsEl.innerHTML = "";
        lastUnitsEl.classList.remove("-visible");
      } else if (quantity > 1) {
        lastUnitsEl.innerHTML = `Últimas ${quantity} unidades disponíveis`;
        lastUnitsEl.classList.add("-visible");
      } else {
        lastUnitsEl.innerHTML = "Última unidade disponível";
        lastUnitsEl.classList.add("-visible");
      }
    } else {
      lastUnitsEl.innerHTML = "";
      lastUnitsEl.classList.remove("-visible");
    }
  },

  handleCartStorage: function (tag) {
    // set item
    localStorage.setItem('related-tag', tag);
  },

  handleSubmit: function (form) {
    if (!form) return;

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      const useLocals = FormPurchase.useLocals;

      const groupShop = form
        .closest("[data-product-box]")
        .getAttribute("data-prod-group-shop");

      // Venda por Locais
      if (
        useLocals &&
        (window.currentLocal == null || !sessionStorage.getItem("local-cep"))
      ) {
        // Caso não tenha local selecionado, abre o popup de inserção do CEP
        const localPopupOpener = document.querySelector(
          "[data-show-locals-popup]"
        );
        localPopupOpener && localPopupOpener.click();
      } else if (groupShop == null) {
        // Adição normal de produto - Compre Junto é controlado em outro componente
        const parent = form.closest("[data-product-box]");

        const respValidated = Store.validateFormProduct(form);
        const boxResponse = parent.querySelector(".msg-response");

        if (respValidated.validated) {
          Store.addProduct(form, parent);
          console.log(form)
          if (form.getAttribute("data-related-tag") != "") {
            FormPurchase.handleCartStorage(form.getAttribute("data-related-tag"));
          }
        } else {
          //console.info('não foi');
          Store.setRespValidateProduct(respValidated, form, boxResponse);
        }
      }
    });
  },

  init: async function (form, markDefaultCheaper) {
    const processed = form.getAttribute("data-processed");
    if (processed === "true") return;

    form.classList.add("-loading");

    FormPurchase.handleOptionsOrder(form);
    FormPurchase.handleDropdowns(form);
    FormPurchase.handleQuantitySelector(form);
    FormPurchase.handleSubmit(form);

    const inputs = form.querySelectorAll("[data-prod-option] input");
    for (const input of inputs) {
      input.checked = false;
      input.addEventListener("change", async () => {
        form.classList.add("-loading");
        Variants.handleLabelDisplay(form, FormPurchase.attrDisplayOrder, input);

        // Aguarda para garantir que todos os inputs foram atualizados
        await new Promise((resolve) => setTimeout(resolve, 150));

        const variant = await Variants.findSelectedVariant(form);
        FormPurchase.handleFormInfos(form, variant);
        FormPurchase.handleOptionNameSelected(form);
        FormPurchase.handleLastUnits(form, variant);
        ValidateForm.validate(form, variant);
        form.classList.remove("-loading");
      });
    }

    // Se o MarkFirstVariant retornar somente uma variante,
    // lida com a exibição do last units e validação do form
    const onlyOneVariant = await MarkFirstVariant.init(
      form,
      this.attrDisplayOrder,
      this.attrMarkFirst,
      markDefaultCheaper
    );
    if (onlyOneVariant) {
      FormPurchase.handleLastUnits(form, onlyOneVariant);
      ValidateForm.validate(form, onlyOneVariant);
    }

    form.classList.remove("-loading");
    form.setAttribute("data-processed", true);
  },
};

export default FormPurchase;
